import { Injectable, inject } from '@angular/core';
import { PreloadingStrategy, Route, Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';

/** '/verificar', '/verificar/<token>', '/verificar?…' (la página pública del QR del carnet). */
const PUBLIC_VERIFICATION_URL = /^\/verificar(?:[/?#;]|$)/;

export function isPublicVerificationUrl(url: string | null | undefined): boolean {
    return PUBLIC_VERIFICATION_URL.test(url ?? '');
}

/**
 * Igual que `PreloadAllModules`, salvo en la página pública de verificación (`/verificar/:token`):
 * ahí no se precarga nada, para que el celular del auditor no descargue los módulos del admin.
 *
 * El `RouterPreloader` vuelve a llamar a esta estrategia en cada `NavigationEnd`, así que al salir
 * de `/verificar` (en la misma pestaña) la precarga se hace normalmente.
 */
@Injectable({ providedIn: 'root' })
export class SkipPublicPreloadingStrategy implements PreloadingStrategy {
    private readonly _router = inject(Router);

    preload(route: Route, load: () => Observable<any>): Observable<any> {
        if (isPublicVerificationUrl(this._router.url)) {
            return of(null);
        }
        // Mismo comportamiento que PreloadAllModules: un chunk que falla no rompe la precarga.
        return load().pipe(catchError(() => of(null)));
    }
}
